import {
    IProps,
} from './types';

import React, {
    FC,
} from 'react';

import {
    PrimaryButton,
} from 'components/buttons';

import styles from './BulkActionBar.module.scss';

const BulkActionBar: FC<IProps> = (props) => {
    return (
        <div className={styles.bulkActionBar}>
            <div className={styles.left}>
                <div>
                    <div>
                        {'Selected: '}
                        {props.selectedCount}
                        {' of '}
                        {props.totalCount}
                    </div>
                    {
                        props.description &&
                        <div>
                            {props.description}
                        </div>
                    }
                </div>
                <div className={styles.actions}>
                    {props.actions}
                </div>
            </div>
            <PrimaryButton
                className={styles.cancelButton}
                onClick={props.onCancel}
            >
                Cancel
            </PrimaryButton>
        </div>
    );
};

export default BulkActionBar;
